export enum ModalStatus {
  Loading = 'loading',
  Idle = 'idle',
  Warning = 'warning',
  Alert = 'alert',
  Success = 'success',
}
